import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import Select from "react-select";
import "./Send_Button_Modal.css";
import Request_Send_Modal from "../../request-send-modal/Request_Send_Modal";

function Send_Button_Modal({ show, handleClose }) {
  const [showRequestSent, setShowRequestSent] = useState(false);
  const materialOptions = [
    { value: "plywood", label: "Plywood" },
    { value: "hardware", label: "Hardware" },
  ];

  const dateOptions = [
    { value: "week", label: "Within a Week" },
    { value: "month", label: "Within a Month" },
  ];

  const radiusOptions = [
    { value: "10", label: "10 KM" },
    { value: "20", label: "20 KM" },
  ];

  const selectStyles = {};
const handleRequestSendClick = () => {
  handleClose();
  setShowRequestSent(true);

  setTimeout(() => {
    setShowRequestSent(false);
  }, 3000); 
};

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="inquiry-modal"
        size="md"
      >
        <Modal.Body className="p-4">
          <Form>
            <div className="Scroll-modal">
              <div className="custom-input-group">
                <span className="floating-label">Full Name</span>
                <Form.Control
                  type="text"
                  defaultValue="Aditya Ramesh Jadhav"
                  className="custom-input"
                  placeholder="Full Name"
                />
              </div>

              <div className="custom-input-group">
                <span className="floating-label">Mobile No</span>
                <Form.Control
                  type="text"
                  defaultValue="+91 4587523254"
                  className="custom-input"
                  placeholder="Mobile No"
                />
              </div>

              <div className="custom-input-group">
                <span className="floating-label">Material</span>
                <Select
                  options={materialOptions}
                  styles={selectStyles}
                  defaultValue={materialOptions[0]}
                  isSearchable={false}
                  placholder="Material"
                />
              </div>

              <div className="custom-input-group">
                <span className="floating-label">Purchase Date</span>
                <Select
                  options={dateOptions}
                  styles={selectStyles}
                  defaultValue={dateOptions[0]}
                  isSearchable={false}
                  placholder="Purchase Date"
                />
              </div>

              <div className="custom-input-group">
                <span className="floating-label">Search Radius</span>
                <Select
                  options={radiusOptions}
                  styles={selectStyles}
                  defaultValue={radiusOptions[0]}
                  isSearchable={false}
                  placholder="Search Radius"
                />
              </div>

              <div className="custom-input-group">
                <span className="floating-label">State</span>
                <Form.Control
                  type="text"
                  placholder="State"
                  className="custom-input"
                />
              </div>

              <div className="custom-input-group">
                <span className="floating-label">District</span>
                <Form.Control
                  type="text"
                  placholder="District"
                  className="custom-input"
                />
              </div>

              <div className="custom-input-group">
                <span className="floating-label">Taluka</span>
                <Form.Control
                  type="text"
                  placholder="Taluka"
                  className="custom-input"
                />
              </div>

              <div className="custom-input-group">
                <span className="floating-label">Area</span>
                <Form.Control
                  type="text"
                  placholder="Area"
                  className="custom-input"
                />
              </div>

              <div className="custom-input-group upload-section">
                <span className="floating-label">
                  Upload Construction Image
                </span>
                <Form.Group controlId="formFile" className="mb-0">
                  <Form.Control
                    type="file"
                    className="custom-file-input"
                    placeholder="Upload Construction Image"
                  />
                </Form.Group>
              </div>
            </div>
            <div className="text-center mt-4">
              <Button
                className="submit-inquiry-pill"
                onClick={handleRequestSendClick}
              >
                Send Inquiry
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Request_Send_Modal
        showRequestSent={showRequestSent}
        handleRequestSendClose={() => setShowRequestSent(false)}
      />
    </>
  );
}

export default Send_Button_Modal;
